"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const NavLink = exports.NavLink = _styledComponents.default.div.withConfig({
  displayName: "Linkstyle__NavLink",
  componentId: "sc-ajqgen-0"
})(["display:block;border-bottom:solid 1px ", ";", " a{display:block;padding:21px 30px 21px 16px;}&:active{background-color:", ";a > div{color:", ";}span{color:", ";}}"], colours.NEUTRALS_5, props => props.type === 'DisabledLink' && "\n    pointer-events: none;\n    padding: 21px 30px 21px 16px;\n    ", colours.PRIMARY_1, colours.WHITE, colours.WHITE);